// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"59":"8f591219","98":"cdbb0add","251":"d726a489","305":"7813e20f","462":"896dac9b","763":"3f6937f3","797":"2ba59193","971":"fa2fa377","974":"4ca3ea32"}[chunkId] + ".chunk.css";
};